const enTranslations = {
  title: "Artem Ryabinin",
  profile: {
    title: "Profile",
    content: "IT developer with over 15 years of industry experience. Full-stack development expert with deep knowledge in backend technologies and AI implementation. Proven track record of successful project delivery for major corporations and startups, combining technical expertise with strategic thinking and leadership qualities."
  },
  expertise: {
    title: "Areas of Expertise",
    items: [
      "Web Development (websites, information portals)",
      "Enterprise Software (CRM and ERP systems)",
      "Custom Software Development for unique business needs",
      "Chatbot and AI Assistant Development",
      "Mobile Application Development",
      "Augmented Reality Systems",
      "Security Auditing and Vulnerability Assessment",
      "Business Analytics and Systems Analysis",
      "Big Data Processing and Analysis using ML and TensorFlow",
      "Development and Training of Neural Networks for Social Media Analysis",
      "Complex Problem Solving and AI Research",
      "Microservice Architecture Design and Implementation",
      "Application Containerization using Docker",
      "Cloud Infrastructure Integration and Deployment with AWS"
    ]
  },
  skills: {
    title: "Key Skills",
    items: [
      "Programming Languages: Go, Python, TypeScript/JavaScript, PHP (early experience)",
      "Frameworks: Django, React, GIN",
      "Backend Development Specialization, deep knowledge of server architecture",
      "Full-stack Development with strong backend focus",
      "UX/UI Design",
      "Project and Development Team Management",
      "Neural Network Implementation in Development",
      "Adaptation to New Technologies and Methodologies",
      "Business Process Optimization, including AI System Integration",
      "Microservice Architecture Design and Implementation",
      "Application Containerization using Docker",
      "AWS Application Deployment and Management",
      "Database Management: PostgreSQL, MongoDB",
      "Experience in High-Load System Development and Optimization"
    ]
  },
  achievements: {
    title: "Professional Achievements",
    items: [
      "Increased development efficiency by 28% through AI tool integration into workflow",
      "Successfully completed over 50 projects for Fortune 500 clients",
      "Founded highly profitable company RownArts, which quickly became a leader in its niche",
      "Developed and implemented an innovative workflow optimization system, increasing team productivity by 32%"
    ]
  },
  experience: {
    title: "Work Experience",
    jobs: [
      {
        title: "Freelancer and Independent Developer",
        period: "2020 - present",
        details: [
          "Specialization in backend development (primarily Go and Python)",
          "Implementation of high-load projects for Moscow State University, Sberbank, and various crypto projects",
          "Implementing AI for development optimization and data analysis since 2021",
          "Development and implementation of innovative backend solutions for performance optimization"
        ]
      },
      {
        title: "UX/UI Specialist and React Developer, Neurodoc",
        period: "2019",
        details: [
          "Created Neurodoc UI/UX system from scratch within tight deadlines",
          "Development of responsive and accessible frontend solutions using React"
        ]
      },
      {
        title: "Lead Frontend Developer, RedCrypto",
        period: "2018",
        details: [
          "Led a team of 5 developers",
          "Implemented Agile methodology, reducing product release time by 40%"
        ]
      },
      {
        title: "Founder and Team Lead, RownArts",
        period: "2013 - 2018",
        details: [
          "Grew company from startup to a team of 15 specialists",
          "Key role in attracting and retaining clients such as Bacardi, Volkswagen Group, Parliament, MTS, Aeroflot, Sber",
          "Development of innovative backend solutions using Python, Django, and .NET MVC"
        ]
      },
      {
        title: "Project Manager, Mosaic Media",
        period: "2013, 5 months",
        details: [
          "Successfully managed parallel development of 3 major projects",
          "Implemented quality control system, reducing bug count by 57%"
        ]
      },
      {
        title: "Freelancer",
        period: "2008 - 2013",
        details: [
          "Completed over 30 projects of varying complexity with focus on backend development",
          "Developed full-stack skills focusing on backend (PHP, later Python) while pursuing university degree",
          "Created and optimized backend systems for clients across various industries"
        ]
      }
    ]
  },
  education: {
    title: "Education",
    items: [
      {
        institution: "Bauman Moscow State Technical University",
        degree: "Mechanical Engineering, 2013",
      }
    ]
  },
  additionalEducation: {
    title: "Additional Education",
    items: [
      "Deep Learning Specialization Course by deeplearning.ai, 2021"
    ]
  },
  earlyExperience: {
    title: "Early Experience",
    content: "Implementation of commercial projects for international clients (AMK technologies, Olga Widman) during high school years"
  },
  additionalInfo: {
    title: "Additional Information",
    items: [
      "Active open-source community member: contributor to Django and TensorFlow projects",
      "Mentor for junior developers in local IT community",
      "Continuous self-education and mastery of cutting-edge technologies"
    ]
  }
};

export default enTranslations;